export default __webpack_public_path__ + "static/media/longCloud17.85ace59c.png";